module.exports = __webpack_public_path__ + "img/Nightmare.jpg";